import { CharacteristicObject } from 'src/app/models/characteristics/characteristic/characteristic-object.model';


export class BillingOffersObject {
    private numberOfInputs: number;
    private numberOfOutputs: number;

    constructor(private id: number, private offer: string, private price: string, private discount: string, private description: string,
        private inputCharacteristics: Array<CharacteristicObject>, private outputCharacteristics: Array<CharacteristicObject>) {
        this.id = id;
        this.offer = offer;
        this.price = price;
        this.discount = discount;
        this.description = description;
        this.inputCharacteristics = inputCharacteristics;
        this.outputCharacteristics = outputCharacteristics;
        this.numberOfInputs = inputCharacteristics.length;
        this.numberOfOutputs = outputCharacteristics.length;
    }

    public getId() {
        return this.id;
    }

    public getInputCharacteristics() {
        return this.inputCharacteristics;
    }

    public getOutputCharacteristics() {
        return this.outputCharacteristics;
    }

    public getNumberOfInputs() {
        return this.numberOfInputs;
    }

    public getNumberOfOutputs() {
        return this.numberOfOutputs;
    }

    public getOffer() {
        return this.offer;
    }
}
